// eslint-disable-next-line import/prefer-default-export
export enum UploadMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
